export default "__VITE_ASSET__Bcu1hb8l__"